import { render, staticRenderFns } from "./FillData.vue?vue&type=template&id=45fa2ba0"
import script from "./FillData.vue?vue&type=script&lang=js"
export * from "./FillData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports